<template>
  <div class="nav-wrapper">
    <b-navbar class="management-nav">
      <b-nav-item
        v-if="$can('access', 'page.users')"
        class="management-item"
        :class="{ active: isSelected('dashboard.users') }"
        :active="isSelected('dashboard.users')"
        :title="labels.adminUsers"
        @click="goTo('dashboard.users')"
      >
        <span :class="{ bold: isSelected('dashboard.users') }">
          {{ labels.adminUsers }}
        </span>
      </b-nav-item>
      <b-nav-item
        v-if="$can('see', 'menu.groups')"
        class="management-item"
        :class="{ active: isSelected('dashboard.groups') }"
        :active="isSelected('dashboard.groups')"
        :title="labels.adminGroups"
        @click="goTo('dashboard.groups')"
      >
        <span :class="{ bold: isSelected('dashboard.groups') }">
          {{ labels.adminGroups }}
        </span>
      </b-nav-item>
      <b-nav-item
        v-if="$can('see', 'menu.admin')"
        class="management-item"
        :class="{ active: isSelected('user-attributes') }"
        :active="isSelected('user-attributes')"
        :title="labels.userAttributes"
        @click="goTo('user-attributes')"
      >
        <span :class="{ bold: isSelected('user-attributes') }">
          {{ labels.userAttributes }}
        </span>
      </b-nav-item>
      <b-nav-item
        v-if="$can('see', 'menu.admin')"
        class="management-item"
        :class="{ active: isSelected('integrations') }"
        :active="isSelected('integrations')"
        :title="labels.integrations"
        @click="goTo('integrations')"
      >
        <span :class="{ bold: isSelected('integrations') }">
          {{ labels.integrations }}
        </span>
      </b-nav-item>
      <b-nav-item
        v-if="$can('see', 'menu.admin')"
        class="management-item"
        :class="{ active: isSelected('account') }"
        :active="isSelected('account')"
        :title="labels.account"
        @click="goTo('account.details')"
      >
        <span :class="{ bold: isSelected('account') }">
          {{ labels.account }}
        </span>
      </b-nav-item>
      <b-nav-item
        v-if="$can('see', 'menu.admin')"
        class="management-item"
        :class="{ active: isSelected('audit-logs') }"
        :active="isSelected('audit-logs')"
        :title="labels.auditLogs"
        @click="goTo('audit-logs')"
      >
        <span :class="{ bold: isSelected('audit-logs') }">
          {{ labels.auditLogs }}
        </span>
      </b-nav-item>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.general.menu
    },
  },
  methods: {
    isSelected(tab) {
      return this.$route.name.includes(tab)
    },
    goTo(name) {
      this.$router.push({ name })
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';
@import '~bootstrap/scss/_functions';
@import '~bootstrap/scss/_variables';
@import '~bootstrap/scss/mixins/breakpoints';

.nav-wrapper {
  overflow: hidden;

  .management-nav {
    z-index: 0;
    box-shadow: 0px 5px 3px rgba(61, 90, 254, 0.1);
    border: 1px solid var(--gray07) !important;
    border-radius: 10px !important;
    padding: 0px;
    margin-bottom: 20px;
    overflow-x: auto;

    .management-item {
      height: 65px;
      width: 160px;
      display: flex;
      align-items: center;
      border-right: 1px solid map-get($theme-colors, 'gray07');

      @include media-breakpoint-down(sm) {
        font-size: 0.8rem !important;
      }

      .nav-link {
        width: 100%;
        text-align: center;
      }

      &:last-child {
        border-right: unset;
      }

      &.active {
        color: map-get($theme-colors, 'secondary');
        border-bottom: 5px solid map-get($theme-colors, 'secondary');
      }

      &.active:first-child {
        border-bottom-left-radius: 10px;
      }
    }
  }
}
</style>
